import { request } from '@/shared/api/request'

export const getData = () => request({ url: `contract/universalMethods/laborStandards`, method: 'get' })

export const getStatistic = () => request({ url: `contract/universalMethods/requestStatistics`, method: 'get' })

export const getCropRai = ({ data, params }) => request({ url: `dict/cropRai/${data}`, method: 'get', params })

export const getCropRegion = (code) => request({ url: `dict/cropRegion/${code}`, method: 'get' })